// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1XLRl","paramInput":"JobSimulator_paramInput__3mNA8","input":"JobSimulator_input__3SLkY"};